import styles from './space.module.scss';


const Space = () => (
  <div className={styles.root} />
)

export default Space
